module.exports = __webpack_public_path__ + "static/media/img-fron.bf29851e.png";